import ReportTable from '../handlers/report-table'

$(document).on(
  'click',
  'table[data-behaviour="report-table"] [data-behaviour~="report-group-expand"]',
  function (_event) {
    const $clickedRow = $(this)
    const rowIndex = $clickedRow.index()

    const $row = $(
      '.report-table-container > table[data-behaviour="report-table"] tbody tr'
    ).eq(rowIndex)

    if ($row.attr('data-collapsed') === 'true') {
      new ReportTable($(document)).expandRow($row)
    } else {
      new ReportTable($(document)).collapseRow($row)
    }
  }
)
